export const GoogleMapsAPI='AIzaSyCquxjb86AERsFjwQoYpne7hmErzfoCto4';
